document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-security-sht]').forEach((root) => {
    const toggle = root.querySelector('[data-security-sht-toggle]');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      const isOpen = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  });
});
